import { combineReducers } from "@reduxjs/toolkit";

import uaeCarFormReducer from "@Features/uaeCarFormSlice";

const rootReducer = combineReducers({
  uaeCarForm: uaeCarFormReducer,
});

export default rootReducer;
